"use client";

import Link from "next/link";
import { CONTACT_EMAIL } from "@/lib/config";
import { ROUTE_GUTTER_CLASS } from "@/lib/route-layout";
import { cn } from "@/lib/utils";

export default function PrivacyPolicy() {
  return (
    <div className={cn("pt-8 pb-6 flex flex-col justify-center items-center min-h-screen text-left bg-background py-6", ROUTE_GUTTER_CLASS)}>
      <h1 className="pt-10 text-5xl font-bold text-foreground mb-4">Privacy Policy for Kraahl</h1>
      <p className="text-lg text-muted-foreground mb-6">Effective Date: 01/01/2025</p>

      <div className="w-full max-w-4xl text-foreground pb-8">
        <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
        <p className="mb-4">
          This Privacy Policy is intended to give an overview of how Kraahl may collect, use, and protect your personal information. The final content will be updated after legal review.
        </p>

        <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
        <p className="mb-4">
          We may collect personal information such as your name, email address, and other contact details, as well as usage data when you access our website.
        </p>

        <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
        <p className="mb-4">
          The information we collect is used to improve our services, personalize your experience, and communicate important updates to you. We do not share your personal information with third parties without your consent, except as required by law.
        </p>
        <p className="mb-4">
          We also analyze and monitor Listings, Posts, communications, and transaction metadata to detect illegal activity, fraud, or attempts to circumvent Kraahl-managed payment flows and fees. This review may include automated signals and manual checks performed under our legitimate interest in keeping the marketplace safe and compliant with applicable laws.
        </p>
        <p className="mb-4">
          Enforcement outcomes—such as the one-strike lifetime ban described in our Terms of Service—may be recorded alongside your account information so that we can prevent repeat abuse and protect other users.
        </p>

        <h2 className="text-2xl font-semibold mb-4">3. Cookies and Tracking Technologies</h2>
        <p className="mb-4">
          We use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and personalize content.
        </p>

        <h2 className="text-2xl font-semibold mb-4">4. Data Security</h2>
        <p className="mb-4">
          We implement reasonable security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
        </p>

        <h2 className="text-2xl font-semibold mb-4">5. Platform Monitoring and Enforcement</h2>
        <p className="mb-4">
          Kraahl reserves the right to monitor, log, and review on-platform communications and Transactions to enforce our Terms of Service, investigate suspected illegal activity, and comply with legal obligations. Monitoring data is handled in accordance with this Privacy Policy and retained only for as long as necessary to fulfill these purposes.
        </p>

        <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
        <p className="mb-4">
          You have the right to access, update, or delete your personal information. If you have any questions or concerns, please contact us at{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-blue-500 underline">
            {CONTACT_EMAIL}
          </a>.
        </p>

        <h2 className="text-2xl font-semibold mb-4">7. Changes to This Privacy Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. Any changes will be posted on this page along with the updated effective date.
        </p>

        <h2 className="text-2xl font-semibold mb-4">8. Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy, please contact us at{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-blue-500 underline">
            {CONTACT_EMAIL}
          </a>{" "}
          or visit our <Link href="/contact" className="text-blue-500 underline">Contact Page</Link>.
        </p>
      </div>
    </div>
  );
}
